import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-primary to-secondary text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Obține fonduri europene mai ușor ca niciodată
            </h1>
            <p className="text-xl mb-8 text-gray-100">
              Conectăm clienții cu profesioniști în consultanță fonduri europene pentru a transforma ideile în proiecte de succes.
            </p>
            <Link
              to="/publish-project"
              className="inline-block px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
            >
              Publică un Proiect
            </Link>
          </div>
        </div>
      </section>

      {/* Beneficii */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">De ce să alegi FonduriEU?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="card text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Proces Rapid</h3>
              <p className="text-gray-600">Găsește rapid profesioniști calificați pentru proiectul tău</p>
            </div>
            <div className="card text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Costuri Optimizate</h3>
              <p className="text-gray-600">Plătești doar când proiectul este de succes</p>
            </div>
            <div className="card text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Profesioniști Verificați</h3>
              <p className="text-gray-600">Toți consultanții sunt verificați și evaluați</p>
            </div>
          </div>
        </div>
      </section>

      {/* Proiecte Recente */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Proiecte Recente</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="card">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">IT</span>
                </div>
                <div>
                  <h3 className="font-semibold">Digitalizare SME</h3>
                  <p className="text-sm text-gray-500">București</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Căutăm consultant pentru digitalizarea proceselor companiei și implementarea unui sistem ERP.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 50.000€</span>
                <button className="btn-secondary text-sm">Vezi detalii</button>
              </div>
            </div>
            <div className="card">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">AG</span>
                </div>
                <div>
                  <h3 className="font-semibold">Agricultură Modernă</h3>
                  <p className="text-sm text-gray-500">Cluj</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Proiect de modernizare a fermei cu tehnologii IoT și sisteme de irigare automată.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 75.000€</span>
                <button className="btn-secondary text-sm">Vezi detalii</button>
              </div>
            </div>
            <div className="card">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">EN</span>
                </div>
                <div>
                  <h3 className="font-semibold">Energie Verde</h3>
                  <p className="text-sm text-gray-500">Timișoara</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">Instalare sisteme fotovoltaice pentru companie și implementare management energetic.</p>
              <div className="flex justify-between items-center">
                <span className="text-primary font-semibold">Buget: 100.000€</span>
                <button className="btn-secondary text-sm">Vezi detalii</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Gata să începi proiectul tău?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Publică proiectul tău acum și primește oferte de la profesioniști calificați în maxim 24 de ore.
          </p>
          <Link
            to="/publish-project"
            className="inline-block px-8 py-4 bg-white text-primary rounded-lg hover:bg-gray-100 transition-colors"
          >
            Publică un proiect
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home; 